import { useQuery } from '@tanstack/react-query';
import { fetchOwnerOperatorVesselHierarchy } from '@api';

export const useLookupOwnerHierarchyQuery = () => {
  return useQuery({
    queryKey: ['ownerHierarchy'],
    placeholderData: [],
    queryFn: ({ signal }) => {
      return fetchOwnerOperatorVesselHierarchy(signal)
        .then((resp) => {
          const { ownerOperatorAssetDetailsList = [] } = resp;
          return ownerOperatorAssetDetailsList;
        })
        .catch(() => []);
    }
  });
};
